import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  typography: {
    fontSize: 16,
  },
  buttonDownloadModel: {
    margin: '20px 0',
    width: '30%',
    paddingInline: '12px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}))

export default styles
